import './Login.scss';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import fnc from '../mymod/commFunction';
import { useDispatch } from 'react-redux';
import { setIsAdmin, setIsLoggedIn, setUserInfo } from '../../reduxToolkit/redux';

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!userId || !password) {
      alert('아이디와 비밀번호를 입력해주세요.');
      return;
    }
    fnc.sendAxios('/loginRoutes/selectUsers', { id: userId, pw: password }, (res) => {
      if (res.error) {
        alert(res.message || '로그인에 실패했습니다.');
        return;
      }
      if (res.success && res.data) {
        const userData = res.data;
        dispatch(setIsLoggedIn(true));
        dispatch(setIsAdmin(false));
        dispatch(setUserInfo({
          userId: userData.id,
          userName: userData.stName || '',
          userKind: userData.userKind || '',
          stCode: userData.stCode || '',
          hp: userData.hp || '',
          email: userData.email || ''
        }));
        navigate('/');
      } else {
        alert('로그인 정보를 확인할 수 없습니다.');
      }
    });
  };

  return (
    <div className='Login'>
      <Helmet>
        <title>로그인 - 매쓰테일러</title>
        <meta name="description" content="매쓰테일러에 로그인하여 PDF HWP 변환, 수학 AI 문제풀이 서비스를 이용하세요." />
        <meta property="og:url" content="https://xn--vl2b19ao0ssqc39r.kr/login" />
      </Helmet>
      <form onSubmit={handleSubmit}>
        <p className='title'>회원 로그인</p>
        <div>
          <label htmlFor='userId'>*아이디</label>
          <input
            id='userId'
            name='userId'
            type='text'
            autoComplete='username'
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor='password'>*비밀번호</label>
          <input
            id='password'
            name='password'
            type='password'
            autoComplete='current-password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <Button variant='contained' className='btnLogin' type='submit'>로그인</Button>
        <div className='find-links'>
          <button type='button' className='link-btn' onClick={() => navigate('/signup')}>
            회원가입
          </button>
          <button type='button' className='link-btn' onClick={() => navigate('/find-id')}>
            아이디 찾기
          </button>
          
          <button type='button' className='link-btn' onClick={() => navigate('/find-password')}>
            비밀번호 찾기
          </button>
        </div>
      </form>
    </div>
  );
}

export default Login;

